
























































import Vue from 'vue'
import { mapState } from 'vuex'
import { CooldownList } from '@/core/cooldowns'
import { ClusterList } from '@/core/clusters'

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: (): [] => [],
    },
  },
  data: () => ({
    dialog: false,
    update: {
      status: undefined,
      plugin: undefined,
      cooldown: undefined,
      clustered: undefined,
    },
  }),
  computed: {
    ...mapState('statuses', {
      statusList: (state: any) => state.items,
    }),
    ...mapState('plugins', {
      pluginList: (state: any) => state.items,
    }),
    cooldownList() {
      return CooldownList
    },
    clusteredList() {
      return ClusterList
    },
  },
  watch: {
    show(newVal) {
      this.reset()
      this.dialog = newVal
    },
  },
  methods: {
    reset() {
      this.update = {
        status: undefined,
        plugin: undefined,
        cooldown: undefined,
        clustered: undefined,
      }
    },
    close() {
      this.$emit('update:show', false)
    },
    submit() {
      this.$emit('submit', this.update)
      this.close()
    },
  },
})
